import React from "react";

const ButtonNextIcon = (props) => {
	return (
		<svg
			width="11"
			height="18"
			viewBox="0 0 11 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				id="Vector 3"
				d="M0.874999 16.918L9.2373 9.76104C9.70367 9.3619 9.70367 8.6407 9.2373 8.24156L0.875 1.08464"
				stroke="#F7F7FC"
				stroke-linecap="round"
			/>
		</svg>
	);
};

export default ButtonNextIcon;
